import AnimatedLetters from '../AnimatedLetters';
import './index.scss';
import Loader  from 'react-loaders';
import { useState,useEffect } from 'react';
import { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

const Contact = () => {

    const [letterClass , setLetterClass] = useState('text-animate');
    const refForm = useRef();


    useEffect(() => {
        // Create a variable to store whether the component is mounted
        let isMounted = true;
      
        const timeoutId = setTimeout(() => {
          // Check if the component is still mounted before setting the state
          if (isMounted) {
            setLetterClass('text-animate-hover');
          }
        }, 3000);
      
        // Set isMounted to false when the component unmounts
        return () => {
          isMounted = false;
          clearTimeout(timeoutId);
        };
      }, []);

      const sendEmail = (e) =>{
        e.preventDefault()

        emailjs
        .sendForm(
            'gmail',
            'buky6180@gmail.com',
             refForm.current,
            '3p3y9C3fsCcX5BGQZM8Cl'




        )
        .then(
            ()=> {
                alert('Message successfully sent!')
                window.location.reload(false)
            },
            ()=> {
                alert('Failed to send the message,please try again')
            }
        )

      }
  
    return (
        <>
            <div className='container contact-page'>
                <div className='text-zone'>
                <h1>
                    <AnimatedLetters
                    letterClass={letterClass}
                     strArray={['C','o','n','t','a','c','t','','m','e']}
                        idx={15}
                        

                    />
                    </h1>
                    <p>
                        I'm intrested in internships as a full stack developer and also in freelance opportunities .However , if you have other request or question, don't hesitate to contact me using below form either
                    </p>
                    <div className='contact-form'>
                        <form ref={refForm} onSubmit={sendEmail} >
                            <ul>
                                <li className='half'>
                                <input type='text' name='name' placeholder='Name' required/>
                                 </li>
                                 <li className='half'>
                                <input
                                 type='email'
                                 name='email' 
                                 placeholder='Email'
                                 required/>
                                 </li>
                                 <li>
                                    <input placeholder='Subject' type='text' name="subject" required />
                                 </li>
                                 <li>
                                    <textarea 
                                    placeholder='Message' 
                                    name='message'
                                    required
                                    ></textarea>
                                 </li>
                                 <li>
                                    <input type='submit'  className='flat-button' value='SEND'/>
                                 </li>

                            </ul>
                        </form>
                    </div>
                
                </div>
                <div className='info-map'>
                    Bhopal, Madhya Pradesh,
                    <br/>
                    India,
                    <br/>
                    IIIT BHOPAL<br/>
                    <span>buky6180@gmail.com</span>
                </div>
                <div className='map-wrap'>
                    <MapContainer center={[23.21789, 77.40878]} zoom={13}>
                        <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'/>
                        <Marker position={[23.21789, 77.40878]}>
                            <Popup>Rahul studies here,come over for a cup of coffee</Popup>
                        </Marker>
                    </MapContainer>
                </div>

            </div>
            <Loader type="pacman"/>
        </>
    )

}

export default Contact

